import React, { ElementType, ReactElement } from "react";
import KunduzLogo from "@icons/kunduzLogo.svg";
import Link from "next/link";
import styles from "./footer.module.scss";

export const FooterAffix = (props: Props): ReactElement => {
  return (
    <div className={styles.affixWrapper}>
      <KunduzLogo className={styles.logo} />
      {props.socialLinks && (
        <div className={styles.socialLinkWrapper}>
          {props.socialLinks.map((s, i) => {
            const { icon: Icon } = s;
            return (
              <Link
                href={s.slug}
                key={i}
                className={styles.socialLink}
                target="_blank"
                rel="nofollow"
              >
                <Icon />
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

interface Props {
  socialLinks?: { icon: ElementType; slug: string }[];
}
